import Config from "../../config";

const Image = ( props ) => {
    return (
        <picture className={`picture`}>
            {
                props.src && <source srcSet={`${Config.urlPublic}/${props.controller}/small/${props.src}`}
                                     media="(max-width: 480px)"/>
            }
            <img src={`${Config.urlPublic}/${props.controller}/${ props.file ? `files/${props.file}` : `${props.size ? props.size : `main`}/${props.src}` }`} height={props.height} width={props.width} alt={ props.name ?? "" } loading={"lazy"} className={`picture__image`} />
        </picture>
    );
}

export default Image;
